import React from 'react';

interface AddButtonProps {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

const AddButton: React.FC<AddButtonProps> = ({
  label,
  onClick,
  icon = (
    <svg
      className="w-5 h-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
}) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-5 py-2.5 bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-500 hover:to-purple-500 text-white text-sm font-semibold rounded-xl shadow-lg shadow-violet-500/25 transition-all duration-200"
    >
      {icon}
      <span>{label}</span>
    </button>
  );
};

export default AddButton;
